module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w80"
  }, [_vm._v(_vm._s(_vm.lang.S0139))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_c('span', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleAll
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.settings), function(setting) {
    return _c('tr', {
      key: setting.ReportingFeatureGuid
    }, [_c('td', {
      staticClass: "td-cb-policies w80"
    }, [_c('span', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          setting.Permitted = !setting.Permitted
        }
      }
    }, [_vm._v(_vm._s(setting.ReportingFeatureName))])]), _vm._v(" "), _c('td', {
      staticClass: "td-cb-policies w20"
    }, [_c('a', {
      staticClass: "btn btn-default btn-cb-policies2",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (setting.Permitted = !setting.Permitted), _vm.$forceUpdate()
        }
      }
    }, [(setting.Permitted) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20380c09","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMgmt/SettingsPoliciesControl.vue
// module id = 610
// module chunks = 1 2